import { createI18n } from 'vue-i18n';
import en from './locales/en-GB.json';
import fr from './locales/fr-FR.json';
import { primeVueLocaleEn, primeVueLocaleFr } from './primevue-locales';

export type SupportedLocale = 'en' | 'fr';

const i18n = createI18n({
  legacy: false,
  locale: 'en',
  fallbackLocale: 'en',
  messages: { en, fr },
});

// Store reference to PrimeVue config for locale switching outside components
let _primeVueConfig: any = null;
let _currentLocale: SupportedLocale = 'en';

export function setPrimeVueConfig(config: any) {
  _primeVueConfig = config;
}

/**
 * Get the BCP 47 locale tag for Intl APIs (formatCurrency, formatDate)
 */
export function getCurrentLocale(): string {
  const localeMap: Record<SupportedLocale, string> = {
    'fr': 'fr-FR',
    'en': 'en-GB',
  };
  return localeMap[_currentLocale] || 'en-GB';
}

/**
 * Get the stored SupportedLocale value (for persisting to DB)
 */
export function getAppLocale(): SupportedLocale {
  return _currentLocale;
}

/**
 * Set the app locale: vue-i18n + PrimeVue
 */
export function setAppLocale(lang: SupportedLocale) {
  _currentLocale = lang;
  i18n.global.locale.value = lang;

  // Update PrimeVue locale
  if (_primeVueConfig) {
    Object.assign(_primeVueConfig.locale, lang === 'fr' ? primeVueLocaleFr : primeVueLocaleEn);
  }
}

/**
 * Detect browser locale
 */
export function detectBrowserLocale(): SupportedLocale {
  const browserLang = navigator.language || (navigator as any).userLanguage || '';
  if (browserLang.startsWith('fr')) return 'fr';
  return 'en';
}

export { primeVueLocaleEn, primeVueLocaleFr };
export default i18n;
